// Pin @monaco-editor/react to the locally-bundled `monaco-editor` package
// instead of its default behaviour, which is to fetch the AMD `loader.js`
// from the jsdelivr CDN. Under the production Content-Security-Policy
// (`script-src 'self' 'unsafe-eval'`) that CDN script is blocked, so the
// editor never initializes. Bundling Monaco locally keeps every script and
// worker same-origin ('self'), satisfying the CSP without loosening it.
//
// This mirrors the desktop app's initializer
// (domains/axilon-ai-desktop/ui/main/src/configs/initializers/monaco-editor-initializer.ts).
// Worker chunks are emitted by Vite's `?worker` import so they are served
// from our own origin rather than a blob/CDN.

// eslint-disable-next-line
// @ts-nocheck

import { logger } from '@axilon-apps/libs-ui-core'
import { loader } from '@monaco-editor/react'
import * as monaco from 'monaco-editor'
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker'
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker'
import cssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker'
import htmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker'
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker'

window.MonacoEnvironment = {
  getWorker(_, label) {
    if (label === 'json') {
      return new jsonWorker()
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new cssWorker()
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new htmlWorker()
    }
    if (label === 'typescript' || label === 'javascript') {
      return new tsWorker()
    }
    return new editorWorker()
  }
}

let initialized = false

const initializeMonacoEditor = (): void => {
  if (initialized) return
  initialized = true

  loader.config({ monaco })

  loader.init().catch((error) => {
    logger.error('Monaco Editor initialization failed', error)
  })
}

export default initializeMonacoEditor
